import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpNetworkPointDetailsBundled
     * @memberof app
     *
     * @restrict E
     *
     * @param {Object} networkPoint `NetworkPointDto` from the backend.
     *
     */
    angular
        .module('app')
        .directive(
            'pkpNetworkPointDetailsBundled',
            pkpNetworkPointDetailsBundled
        );

    function pkpNetworkPointDetailsBundled() {
        return {
            restrict: 'E',
            scope: {
                networkPoint: '='
            },
            template:
                require('app/_directives/pkp-network-point-details-bundled.directive.html')
        };
    }
})();
